import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as firebase from 'firebase';
import userStore from '../../stores/UserStore';

/**
 * Receives sessionid and uid props from simulationContainer
 *
 * this component acts as the simulationContainer for all
 * components in the actual orderbook.
 */
class DealerBox extends Component {
    constructor(props) {
        //console.log("OrderbookContainer created");
        super(props);
        this.kickUser = this.kickUser.bind(this);
        this.isSolo = this.isSolo.bind(this);
    }

    renderDealerUser(props){
        console.log('RENDERING DEALERS');
        return (
            <div
            style={{
                background: "#2D3748",
                borderRadius: "0.5rem",
                padding: "0.75rem 1rem",
                marginBottom: "0.5rem",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                color: "white",
            }}
            className={((this.props.player.id == userStore.uid) ? `active dealerBoxStyle box-${this.props.player.cssClass}` : `dealerBoxStyle box-${this.props.player.cssClass}`)}>
            {this.props.player.cssClass.includes("Bid") ?  (
                <div
                style={{
                    width: "6px",
                    height: "100%",
                    borderRadius: "3px",
                    marginRight: "10px",
                    marginLeft: "10px",
                }}
                className={`dealerBoxStyle box-${this.props.player.cssClass}`}
                ></div>
            ) : null}
              <h5><span className={"playername "+this.props.columnType}>{this.props.player.name}</span> <span className={"price " + this.props.columnType}>{this.props.player.price}</span></h5>
              <h6 className={"position "+ (this.props.showPos || 'hide')}>{this.props.player.position}</h6>
              {this.props.player.cssClass.includes("Ask") ?  (
                <div
                style={{
                    width: "6px",
                    height: "100%",
                    borderRadius: "3px",
                    marginRight: "10px",
                    marginLeft: "10px"
                }}
                className={`dealerBoxStyle box-${this.props.player.cssClass}`}
                ></div>
            ) : null}
            </div>
        );
    }

    renderMarketUser(props){
        console.log('RENDERING MARKET USERS');
        return (
            <div></div>
        );
    }

    renderCorrectUser(props){
        console.log('RENDERING CORRECT USERS');
        const isDealer = props.isDealer;
        if(isDealer){
            return (<renderDealerUser/>);
        }
        else{
            return (<renderMarketUser/>);
        }
    }

    kickUser(){
        if((this.props.player.id).substring(0,3) != "bot"){
            let userRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Users").child(this.props.player.id).child("didUserLeave");
            userRef.set({ "didUserLeave": true });
        }
        else{
            alert('Cannot delete a bot');
        }
    }

    isSolo(){
        let solo;
        let dbRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Info").child("Solo").once("value", ss =>{
            solo = ss.val();
            if(solo == true){
                // alert(solo);
                return true;
            }
            else{
                // alert(solo);
                return false; 
            }
        });
    }

    componentDidMount() {

    }

    componentWillUnmount() {
    }

    /**
     * Conditionally renders limit orders based on state.ready
     * @returns {*}
     */
    render() {
        //console.log("OrderbookContainer render");
        //console.log(this.state.userSums);
        
        return(
        <div
            style={{
                background: "#2D3748",
                borderRadius: "0.5rem",
                padding: "0.75rem 1rem",
                marginBottom: "0.5rem",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                color: "white",
            }}
            className={((this.props.player.id == userStore.uid) ? `active dealerBoxStyle box-${this.props.player.cssClass}` : `dealerBoxStyle box-${this.props.player.cssClass}`)}>
            {this.props.player.cssClass.includes("Bid") ?  (
                <div
                style={{
                    width: "6px",
                    height: "100%",
                    borderRadius: "3px",
                    marginRight: "10px",
                    marginLeft: "10px",
                }}
                className={`dealerBoxStyle box-${this.props.player.cssClass}`}
                ></div>
            ) : null}
            <h5><span className={"playername "+this.props.columnType}>{this.props.player.name}</span> <span className={"price " + this.props.columnType}>{this.props.player.price}</span></h5>
                <h6 className={"position "+ (this.props.showPos || 'true' )}>{this.props.player.position}</h6>
        {this.props.player.cssClass.includes("Ask") ?  (
                <div
                style={{
                    width: "6px",
                    height: "100%",
                    borderRadius: "3px",
                    marginRight: "10px",
                    marginLeft: "10px"
                }}
                className={`dealerBoxStyle box-${this.props.player.cssClass}`}
                ></div>
            ) : null}
        </div>

    );
        

    }
}

export default DealerBox;



// WEBPACK FOOTER //
// ./src/components/Orderbook/DealerBox.js